import React from 'react';
import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TreeSelect } from 'antd';
import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useAppDispatch } from '@store/hooks';
import { fetchUnpaidInvoices } from '@store/Finance/AP/ApInvoices/UnpaidInvoicesSlice';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
import { getUnApplyPrepaymentsListByPeopleId } from '@store/Finance/AP/ApPayments/ApPaymentsSlice';

export const ApplyPrePaymentComponent: React.FC<{
  formik: any;
  onClose: () => void;
  OperatingUnitOptions: any[];
  treeSuppliersData: any[];
}> = ({ formik, onClose, OperatingUnitOptions, treeSuppliersData }) => {
  const { values, setFieldValue } = formik;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // State خاص بالمكون
  const [prepaymentList, setPrepaymentList] = useState<any[]>([]);
  const [standardInvoices, setStandardInvoices] = useState<any[]>([]);
  const [selectedPrepayment, setSelectedPrepayment] = useState<any>(null);
  const [appliedStandardInvoices, setAppliedStandardInvoices] = useState<Map<string, number>>(new Map());
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState<string | null>(null);

  const resetState = () => {
    setPrepaymentList([]);
    setStandardInvoices([]);
    setSelectedPrepayment(null);
    setAppliedStandardInvoices(new Map());
    setFetchError(null);
    setIsLoading(false);
  };

  const handleGetUnpaidInvoices = async () => {
    if (!values.organizationId || !values.peopleId) return;

    setIsLoading(true);
    setFetchError(null);

    try {
      const [prepaymentResult, standardResult] = await Promise.all([
        // dispatch(getUnApplyPrepaymentsListByPeopleId(values.peopleId)).unwrap(),
        dispatch(
          getUnApplyPrepaymentsListByPeopleId({
            peopleId: values.peopleId,
            organizationId: values.organizationId
          })
        ).unwrap(),

        dispatch(
          fetchUnpaidInvoices({
            peopleId: values.peopleId,
            organizationId: values.organizationId,
            invoiceType: 'Standard'
          })
        ).unwrap()
      ]);

      let prepaymentData: any[] = [];
      let standardData: any[] = [];
      // debugger
      if (prepaymentResult.succeeded) {
        prepaymentData = prepaymentResult.data.map((prepayment: any) => ({
          amount: prepayment.amount,
          amountUnApply: prepayment.amountUnApply,
          code: prepayment.code,
          id: prepayment.id,
          paymentDate: prepayment.paymentDate
        }));
        setPrepaymentList(prepaymentData);
      }

      if (standardResult.succeeded) {
        standardData = standardResult.data.map((invoice: any) => ({
          ...invoice,
          invoiceType: 'Standard',
          id: invoice.apPaymentScheduleId
        }));
        setStandardInvoices(standardData);
      }

      if (!prepaymentResult.succeeded || prepaymentData.length === 0) {
        setFetchError('لا توجد دفعات مقدمة للمقاصة');
      } else if (!standardResult.succeeded || standardData.length === 0) {
        setFetchError('لا توجد فواتير عادية للمقاصة');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setFetchError('فشل في جلب البيانات');
    } finally {
      setIsLoading(false);
    }
  };

  const handlePrepaymentSelection = (prepayment: any) => {
    setSelectedPrepayment(prepayment);
  };

  const handleAppliedAmountChange = (invoiceId: string, amount: number) => {
    const invoice = standardInvoices.find(inv => inv.apPaymentScheduleId === invoiceId);
    if (!invoice) return;

    const maxAmount = Math.min(invoice.remainingAmount, selectedPrepayment?.amountUnApply || 0);
    const finalAmount = Math.max(0, Math.min(amount, maxAmount));

    const updatedApplied = new Map(appliedStandardInvoices);

    if (finalAmount > 0) {
      updatedApplied.set(invoiceId, finalAmount);
    } else {
      updatedApplied.delete(invoiceId);
    }

    setAppliedStandardInvoices(updatedApplied);
  };

  const handleSubmit = () => {
    if (!selectedPrepayment) {
      alert('يجب اختيار دفعة مقدمة واحدة');
      return;
    }

    if (appliedStandardInvoices.size === 0) {
      alert('يجب إدخال مبالغ للفواتير العادية');
      return;
    }

    if (!isFormValid) {
      return;
    }

    const totalAppliedAmount = Array.from(appliedStandardInvoices.values()).reduce((sum, amount) => sum + amount, 0);
    const prepaymentAmount = selectedPrepayment.amountUnApply;

    if (totalAppliedAmount > prepaymentAmount) {
      alert(
        `المبلغ الإجمالي المطبق (${totalAppliedAmount.toLocaleString()}) لا يمكن أن يتجاوز رصيد الدفعة المقدمة (${prepaymentAmount.toLocaleString()})`
      );
      return;
    }

    // إعداد بيانات الفواتير العادية (كهدف)
    const appliedInvoicesData = Array.from(appliedStandardInvoices.entries()).map(([scheduleId, appliedAmount]) => {
      const invoice = standardInvoices.find(inv => inv.apPaymentScheduleId === scheduleId);
      return {
        id: null,
        apPaymentScheduleId: invoice.apPaymentScheduleId,
        invoiceNum: invoice.invoiceNum,
        invoiceDate: invoice.invoiceDate,
        dueDate: invoice.dueDate,
        invoiceAmount: invoice.invoiceAmount,
        schadualAmount: invoice.schadualAmount || 0,
        amount: appliedAmount,
        actualRemainingAmount: invoice.remainingAmount,
        invoiceType: 'Standard'
      };
    });

    formik?.setFieldValue('scheduleList', appliedInvoicesData);
    formik?.setFieldValue('prePaymentId', selectedPrepayment.id);

    // console.log(appliedInvoicesData);

    onClose();
  };

  const columns = [
    { title: 'رقم الفاتورة', key: 'invoiceNum' },
    { title: 'التاريخ', key: 'invoiceDate' },
    { title: 'تاريخ الاستحقاق', key: 'dueDate' },
    { title: 'المبلغ الأصلي', key: 'originalAmount' },
    { title: 'الرصيد المتبقي', key: 'remainingAmount' },
    { title: 'المبلغ المطبق', key: 'appliedAmount' },
    { title: 'الرصيد بعد التطبيق', key: 'balanceAfter' }
  ];

  const sortedStandardInvoices = [...standardInvoices].sort((a, b) => {
    // ترتيب تصاعدي (من الأقدم إلى الأحدث) حسب تاريخ الفاتورة
    const dateA = a.invoiceDate ? new Date(a.invoiceDate).getTime() : Infinity;
    const dateB = b.invoiceDate ? new Date(b.invoiceDate).getTime() : Infinity;
    return dateA - dateB;
  });

  const getTableData = () => {
    // return standardInvoices.map(invoice => {
    return sortedStandardInvoices.map(invoice => {
      const appliedAmount = appliedStandardInvoices.get(invoice.apPaymentScheduleId) || 0;
      const remainingBalance = invoice.remainingAmount - appliedAmount;
      const balanceAfter = Math.max(0, remainingBalance);

      return {
        invoiceNum: (
          <div>
            <div className='fw-bold'>{invoice.invoiceNum}</div>
            {/* <small className='text-muted'>دفع: {invoice.paymentNum}</small> */}
          </div>
        ),
        invoiceDate: <div className='text-center'>{invoice.invoiceDate?.split('T')[0]}</div>,
        dueDate: (
          <div
            className={`text-center ${new Date(invoice.dueDate) < new Date() ? 'text-danger fw-bold' : 'text-dark'}`}
          >
            {invoice.dueDate?.split('T')[0]}
            {/* {new Date(invoice.dueDate) < new Date() && (
              <div>
                <small className='text-danger'>متأخرة</small>
              </div>
            )} */}
          </div>
        ),
        originalAmount: <div className='text-center text-muted'>{Number(invoice.invoiceAmount).toLocaleString()}</div>,
        remainingAmount: (
          <div className={`text-center fw-bold ${invoice.remainingAmount > 0 ? 'text-primary' : 'text-success'}`}>
            {Number(invoice.remainingAmount).toLocaleString()}
          </div>
        ),
        appliedAmount: (
          <div className='text-center'>
            <Form.Control
              type='number'
              value={appliedAmount || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const value = parseFloat(e.target.value) || 0;
                handleAppliedAmountChange(invoice.apPaymentScheduleId, value);
              }}
              onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                const value = parseFloat(e.target.value) || 0;
                handleAppliedAmountChange(invoice.apPaymentScheduleId, value);
              }}
              step='0.01'
              min='0'
              max={Math.min(invoice.remainingAmount, selectedPrepayment?.amountUnApply || 0)}
              className='text-center fw-bold border-warning'
              style={{ width: '130px' }}
              placeholder='0'
            />
          </div>
        ),
        balanceAfter: (
          <div className={`text-center fw-bold ${balanceAfter > 0 ? 'text-warning' : 'text-success'}`}>
            {balanceAfter.toLocaleString()}
            {balanceAfter === 0 && (
              <div>
                <small className='text-success'>مستنفذ</small>
              </div>
            )}
          </div>
        )
      };
    });
  };

  // 🔹 مجموع المبالغ المطبقة على الفواتير القياسية
  const totalAppliedAmount = Array.from(appliedStandardInvoices.values()).reduce((sum, amount) => sum + amount, 0);

  // 🔹 المبلغ الكامل للدفعة المقدمة
  const prepaymentTotal = selectedPrepayment?.amount || 0;

  // 🔹 المبلغ غير المطبق (المتبقي حالياً في النظام قبل التطبيق الجديد)
  const prepaymentUnapplied = selectedPrepayment?.amountUnApply || 0;

  // 🔹 المبلغ المتبقي بعد التطبيق الحالي
  // بمعنى: المبلغ غير المطبق - المبالغ الجديدة التي يريد المستخدم تطبيقها الآن
  const remainingPrepaymentAmount = prepaymentUnapplied - totalAppliedAmount;

  // 🔹 التحقق من أن المستخدم لم يتجاوز المبلغ المتاح
  const isAmountValid = totalAppliedAmount <= prepaymentUnapplied;

  // 🔹 تحقق شامل من صلاحية النموذج
  const isFormValid = !!selectedPrepayment && appliedStandardInvoices.size > 0 && isAmountValid;

  return (
    <>
      <div className='row g-3 mb-4'>
        {/* المورد والوحدة التشغيلية */}
        <div className='col-lg-5'>
          <div className='form-group'>
            <label className='form-label fw-bold'>المورد</label>
            <TreeSelect
              showSearch
              className='w-100'
              treeLine
              placeholder='اختر المورد'
              allowClear
              value={values.peopleId}
              onChange={option => {
                resetState();
                formik.setFieldValue('peopleId', option === null ? null : option);
              }}
              treeData={treeSuppliersData}
              treeNodeFilterProp='title'
              getPopupContainer={triggerNode => triggerNode.parentNode}
            />
          </div>
        </div>

        <div className='col-lg-5'>
          <div className='form-group'>
            <label className='form-label fw-bold'>الوحدة التشغيلية</label>
            <Select
              isSearchable={true}
              isClearable
              options={OperatingUnitOptions}
              value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
              onChange={(option: any) => {
                resetState();
                setFieldValue('organizationId', option === null ? null : option.value);
              }}
              placeholder='اختر الوحدة التشغيلية'
              className='react-select-container'
              classNamePrefix='react-select'
            />
          </div>
        </div>

        <div className='col-lg-2'>
          <div className='form-group h-100 d-flex flex-column justify-content-end'>
            <button
              disabled={isLoading || !values.organizationId || !values.peopleId}
              type='button'
              className='btn btn-sm btn-outline-theme w-100 py-2'
              onClick={handleGetUnpaidInvoices}
            >
              {isLoading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2'></span>
                  جاري التحميل...
                </>
              ) : (
                <>
                  <i className='fas fa-download me-2'></i>
                  جلب البيانات
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      {fetchError && (
        <div className='alert alert-warning d-flex align-items-center mb-4' role='alert'>
          <i className='fas fa-exclamation-triangle me-2'></i>
          <div>{fetchError}</div>
        </div>
      )}
      {/* الدفعات المقدمة */}

      {prepaymentList.length > 0 && (
        <div className='row mb-4'>
          <div className='col-12'>
            <Card className='border-warning'>
              <CardHeader className='bg-warning bg-opacity-10 border-warning d-flex justify-content-between align-items-center py-3'>
                <h6 className='mb-0 '>
                  <i className='fas fa-hand-holding-usd me-2 text-warning'></i>
                  اختر الدفعة المقدمة
                </h6>
                <span className='badge bg-warning '>{prepaymentList.length} دفعة متاحة</span>
              </CardHeader>
              <CardBody className='p-0'>
                <div className='list-group list-group-flush'>
                  {prepaymentList.map((prepayment, index) => (
                    <div
                      key={prepayment.id}
                      className={`list-group-item list-group-item-action border-bottom ${
                        selectedPrepayment?.id === prepayment.id
                          ? ' bg-warning bg-opacity-10 border-warning border-1'
                          : 'border-light'
                      }`}
                      onClick={() => handlePrepaymentSelection(prepayment)}
                      style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                    >
                      <div className='d-flex justify-content-between align-items-start'>
                        <div className='d-flex align-items-start flex-grow-1'>
                          <div className='form-check mt-1 me-3'>
                            <input
                              type='radio'
                              className='form-check-input'
                              name='prepaymentInvoice'
                              checked={selectedPrepayment?.id === prepayment.id}
                              onChange={() => handlePrepaymentSelection(prepayment)}
                            />
                          </div>
                          <div className='flex-grow-1'>
                            <div className='d-flex align-items-center mb-2'>
                              <h6 className='mb-0 me-3'>{prepayment.code}</h6>
                              <span className='badge bg-light  small'>
                                <i className='fas fa-calendar me-1'></i>
                                {prepayment.paymentDate?.split('T')[0]}
                              </span>
                            </div>

                            <div className='row g-3'>
                              <div className='col-auto'>
                                <div className='d-flex flex-column'>
                                  <small className='mb-1'>المبلغ الكامل</small>
                                  <span className='fw-bold  fs-6'>
                                    {Number(prepayment.amount).toLocaleString()}
                                    {/* <small className='text-muted ms-1'>ر.س</small> */}
                                  </span>
                                </div>
                              </div>

                              <div className='col-auto'>
                                <div className='vr h-100'></div>
                              </div>

                              <div className='col-auto'>
                                <div className='d-flex flex-column'>
                                  <small className='text-muted mb-1'>المبلغ المتبقي</small>
                                  <span className='fw-bold text-warning fs-6'>
                                    {Number(prepayment.amountUnApply).toLocaleString()}
                                    {/* <small className='text-muted ms-1'>ر.س</small> */}
                                  </span>
                                </div>
                              </div>

                              <div className='col-auto'>
                                <div className='vr h-100'></div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='text-end ms-3'>
                          <div className='d-flex flex-column align-items-end'>
                            <span
                              className={`badge fs-6 ${
                                selectedPrepayment?.id === prepayment.id ? 'bg-dark text-warning' : 'bg-warning '
                              }`}
                            >
                              {Number(prepayment.amountUnApply).toLocaleString()}
                            </span>
                            <small className='text-muted mt-1'>
                              متبقي من {Number(prepayment.amount).toLocaleString()}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      )}

      {/* ملخص المقاصة */}
      {(selectedPrepayment || appliedStandardInvoices.size > 0) && (
        <div className={`alert ${isAmountValid ? 'alert-success' : 'alert-warning'} mb-4`}>
          <div className='row text-center'>
            <div className='col-md-3 border-end'>
              <div className='small text-muted'>رصيد الدفعة المقدمة</div>
              {/* <div className='h5 fw-bold text-warning'>{totalPrepaymentAmount.toLocaleString()}</div> */}
              <div className='h5 fw-bold text-warning'>{prepaymentTotal.toLocaleString()}</div>
              {selectedPrepayment && <small className='text-muted'>دفعة: {selectedPrepayment.code}</small>}
            </div>
            <div className='col-md-3 border-end'>
              <div className='small text-muted'>المبلغ المطبق</div>
              <div className='h5 fw-bold text-primary'>{totalAppliedAmount.toLocaleString()}</div>
              <small className='text-muted'>على {appliedStandardInvoices.size} فاتورة</small>
            </div>
            <div className='col-md-3 border-end'>
              <div className='small text-muted'>الرصيد المتبقي</div>
              <div className={`h5 fw-bold ${remainingPrepaymentAmount > 0 ? 'text-success' : 'text-danger'}`}>
                {remainingPrepaymentAmount.toLocaleString()}
              </div>
            </div>
            <div className='col-md-3'>
              <div className='small text-muted'>الحالة</div>
              <div className={`h6 fw-bold ${isAmountValid ? 'text-success' : 'text-danger'}`}>
                {isAmountValid ? 'المبلغ ضمن الحدود' : 'المبلغ تجاوز الرصيد'}
              </div>
            </div>
          </div>
          {!isAmountValid && (
            <div className='mt-2 text-center'>
              <i className='fas fa-exclamation-triangle me-2'></i>
              المبلغ المطبق لا يمكن أن يتجاوز رصيد الدفعة المقدمة
            </div>
          )}
        </div>
      )}

      {/* جدول الفواتير العادية */}
      {standardInvoices.length > 0 && selectedPrepayment && (
        <div className='row'>
          <div className='col-12'>
            <Card className='border-primary'>
              <CardHeader className='  d-flex justify-content-between align-items-center'>
                <h6 className='mb-0'>
                  <i className='fas fa-file-invoice me-2'></i>
                  قائمة الفواتير غير المدفوعة
                </h6>
              </CardHeader>
              <CardBody className='p-0'>
                {/* <div className='table-responsive'> */}
                <div className='table-responsive' style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  <table className='table table-hover mb-0'>
                    <thead
                      className='table-primary'
                      style={{ position: 'sticky', top: 0, zIndex: 1, backdropFilter: 'blur(20px)' }}
                    >
                      <tr>
                        {columns.map((col, index) => (
                          <th key={index} className='text-center small'>
                            {col.title}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {getTableData().map((row, rowIndex) => {
                        const invoiceId = standardInvoices[rowIndex]?.apPaymentScheduleId;
                        const appliedAmount = appliedStandardInvoices.get(invoiceId) || 0;

                        return (
                          <tr
                            key={rowIndex}
                            className={appliedAmount > 0 ? 'table-active bg-primary bg-opacity-10' : ''}
                          >
                            {columns.map((col, colIndex) => (
                              <td key={colIndex} className='text-center align-middle'>
                                {row[col.key as keyof typeof row]}
                              </td>
                            ))}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
              <CardFooter className='d-flex justify-content-between align-items-center'>
                <div className='text-muted small'>
                  {appliedStandardInvoices.size} / {standardInvoices.length} فاتورة مختارة
                </div>
                <div className='fw-bold text-primary'>الإجمالي المطبق: {totalAppliedAmount.toLocaleString()}</div>
              </CardFooter>
            </Card>
          </div>
        </div>
      )}

      <div className='border-top mt-4 pt-4'>
        <div className='d-flex justify-content-between align-items-center'>
          <div></div>
          <div className='d-flex'>
            <button disabled={!isFormValid} className='btn btn-theme me-2 px-4' onClick={handleSubmit}>
              <i className='fas fa-check-circle me-2'></i>
              استمرار
            </button>
            <button
              type='button'
              className='btn btn-outline-secondary'
              onClick={() => navigate('/AP/ApPayments', { replace: true })}
            >
              <i className='fas fa-times me-2'></i>
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
